export default {
  notificationChannels: 'Benachrichtigungskanäle',
  userSubscription: 'Benutzer-Abonnements',
};
